<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div class="modal-header">
  <div class="modal-title f-20">Rules </div>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true" (click)="closeAction()"></button>
</div>
<div class="modal-body">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-7">
        <div class="form-group">
          <div class="left inline control-label mb-1">Key Word Search</div>
          <input class="form-control form-control-sm mat-autodd-input" [(ngModel)]="keyword" >
        </div>
      </div>
      <div class="col-md-2 pt-4">
        <button class="btn bg-g-lightGreen btn-sm pull-right ml-2" (click)="keywordSearch()">Submit</button>
        <button class="btn bg-g-lightGreen btn-sm pull-right" (click)="resetKeyWords()">Reset</button>
      </div>
      <!-- <div class="col-md-12 text-left">
        <div class="text-blue" *ngIf="(rulesConnectionData && (rulesConnectionData.length>0))">
          <div>{{endIndex}} out of {{totalCount}}</div>
        </div>
      </div> -->
      <div class="table-responsive box-shadow table-cont body-style">
        <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
        <table  class="table table-fixed rules-connection-table table-hover mb-0">
          <thead>
            <tr>
              <th style="width: 5%;"></th>
              <th style="width: 10%;" (click)="sortBreifRulebooks('id')">Id
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filter.SortKey === 'id' && !filter.IsDesc),
                'fa-sort-amount-desc': (filter.SortKey === 'id' && filter.IsDesc) }"
                      aria-hidden="true">
                  </i>
              </th>
              <th style="width: 15%" (click)="sortBreifRulebooks('ruleBook')" >RuleBook
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filter.SortKey === 'ruleBook' && !filter.IsDesc),
                'fa-sort-amount-desc': (filter.SortKey === 'ruleBook' && filter.IsDesc) }"
                      aria-hidden="true">
                  </i>
              </th>
              <th style="width: 50%;" (click)="sortBreifRulebooks('part')" >Part
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filter.SortKey === 'part' && !filter.IsDesc),
                'fa-sort-amount-desc': (filter.SortKey === 'part' && filter.IsDesc) }"
                      aria-hidden="true">
                  </i>
              </th>
              <th style="width: 20%;" (click)="sortBreifRulebooks('ruleId')" >Rule ID
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filter.SortKey === 'ruleId' && !filter.IsDesc),
                'fa-sort-amount-desc': (filter.SortKey === 'ruleId' && filter.IsDesc) }"
                      aria-hidden="true">
                  </i>
              </th>
            </tr>
          </thead>
          <tbody *ngIf="rulesConnectionData.length === 0">
            <tr>
              <td>No Data</td>
            </tr>
          </tbody>
          <tbody #tableBody *ngIf="(rulesConnectionData && (rulesConnectionData.length > 0))" [style.max-height.px]="myInnerHeight">
            <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="35"
              (scrolledIndexChange)="handler($event)" [style.height.px]="myInnerHeight"
              *ngIf="rulesConnectionData.length > 0">
              <div *cdkVirtualFor="let item of rulesConnectionData; let i = index">
                <tr>
                  <td style="width: 5%;">
                    <input type="checkbox" [attr.checked]="checkedIfExist(item.id) ? checkedIfExist(item.id) : null"
                    [attr.disabled]="(item.id === this.linkedConnection.currentID) || (item.id === this.linkedAppliedAcross.currentID)  ? 'disabled' : null" (change)="selectItem($event, item.id)" />
                  </td>
                  <td style="width: 10%;">{{item.id}}</td>
                  <td style="width: 15%;">{{item.ruleBook}}</td>
                  <td style="width: 50%;">{{item.part}}</td>
                  <td style="width: 20%;">{{item.ruleId}}</td>
                </tr>
              </div>
            </cdk-virtual-scroll-viewport>
          </tbody>
        </table>
        <mat-paginator [length]="totalCount"
               [pageIndex]="pageIndex"
               [pageSize]="pageSize"
               [pageSizeOptions]="[10, 20, 30]"
               aria-label="Select page"
               (page)="onPagechange($event)"
               [showFirstLastButtons]="showFirstLastButtons"
               class="pannel_container_paginatorFixed left-50">
        </mat-paginator>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn bg-g-lightGreen btn-sm" (click)="closeDialog()">Save</button>
</div>

